import { IAllProps } from '@tinymce/tinymce-react';
import RichTextEditor from '../../../component/richtext-editor';

const NhapKetQuaCDHAEditor = (props: IAllProps) => {
	const getTableCellNode = (node: Node) => {
		if (node.nodeName === 'TD') return node;

		while (node.parentNode) {
			node = node.parentNode;
			if (node.nodeName === 'TD') return node;
		}

		return false;
	};

	return (
		<RichTextEditor
			onDrop={(e: DragEvent) => {
				const targetElement = e.target as HTMLElement;
				const file = e.dataTransfer?.files[0];
				const tableCellTarget = getTableCellNode(targetElement);
				let cellHeight = 0;

				if (!file || !tableCellTarget) return;
				cellHeight = (tableCellTarget as HTMLTableCellElement).clientHeight;

				if (tableCellTarget) {
					e.preventDefault();

					const reader = new FileReader();
					reader.addEventListener('load', () => {
						const base64 = reader.result as string;
						const img = document.createElement('img');
						const target = tableCellTarget as HTMLTableCellElement;
						target.style.padding = '0';
						target.style.height = `${cellHeight}px`;

						img.style.width = `${target.clientWidth}px`;
						img.style.height = `${target.clientHeight}px`;
						img.style.objectFit = 'contain';
						img.style.display = 'block';
						img.style.margin = '0 auto';
						img.src = base64;

						targetElement.replaceChildren(img);
					});
					reader.readAsDataURL(file);
				}
			}}
			{...props}
		/>
	);
};

export default NhapKetQuaCDHAEditor;
